import script from "./AnswerRates.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerRates.vue?vue&type=script&setup=true&lang=js"

import "./AnswerRates.vue?vue&type=style&index=0&id=653f18c3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653f18c3"]])

export default __exports__